var _classCallCheck = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var OrangeChartAbstractBars = require('./orange-chart-abstract-bars');
var OrangeChartBars = /*#__PURE__*/function (_OrangeChartAbstractB) {
  "use strict";

  _inherits(OrangeChartBars, _OrangeChartAbstractB);
  var _super = _createSuper(OrangeChartBars);
  function OrangeChartBars() {
    _classCallCheck(this, OrangeChartBars);
    return _super.apply(this, arguments);
  }
  _createClass(OrangeChartBars, [{
    key: "chart_sub_type_code",
    get:
    /**
     * Chart subtype
     *
     * @type {string}
     * @static
     */
    function get() {
      return 'vertical';
    }

    /**
     * Function for calculating label position for labels on X axis
     *
     * @type {function(number, number, object): number}
     * @protected
     */
  }, {
    key: "_x_axis_label_position_function",
    get: function get() {
      var _this = this;
      return function (i, size, view) {
        var rd = _this._calculate_data_for_render(size, view, _this._axes.y._config.label);
        return (rd.margin + rd.bar_size) * i + rd.bar_size * 0.5 + (rd.side_margin_adjustment > 0 ? rd.margin : 0);
      };
    }
  }]);
  return OrangeChartBars;
}(OrangeChartAbstractBars);
module.exports = OrangeChartBars;